import BookConsultation from '../../components/BookConsultation/BookConsultation';

export default function BookConsultationPage() {
  return <BookConsultation />;
}
